<template>
<div style="background:#fcfcfd;padding-top:50px;">
    <div class="container">
        <div class="row align-items-center " style="padding-bottom:40px">
            <div class="col-12 col-md-6 order-md-2">
                <div class="bc-video-player" style="width: 100%; height: 100%;">
                <video preload="metadata" style="width:100%" autoplay="true" muted="" id="video"
poster="/static/images/video.jpg" playsinline="" webkit-playsinline="" @οncanplay="canplay()">
                    <source 
src="//cloud.video.alibaba.com/play/u/2153292369/p/1/e/6/t/1/d/hd/317537464684.mp4">
                </video>
            </div>            
            </div>
            <div class="col-12 col-md-6 order-md-1 aos-init aos-animate" data-aos="fade-up" style="text-align:left">
               
                <p class="header-text text-md-start" style="color:#526193">
                    {{$t('home_title')}}
                </p>
                 <p style="color:#333 !important;font-size:15px;line-height:25px">
                    {{$t('home_desc_1')}}
                    </p>

                    <p style="color:#333 !important;font-size:15px;line-height:25px">
                        {{$t('home_desc_2')}}
                    </p><p style="text-align:right">
                    <button type="button" @click="gotoUrl('aboutus')" class="btn btn-primary" style="border-radius:25px;padding:10px 20px;background:#526193 !important;border:1px solid #826e9e">{{$t('home_view_detail')}}</button>
                    </p>
            </div>
        </div>
    </div>
    <div class="block-reverse">
        <div class="container" style="padding:30px 10px">
            <div style="color:#526193;font-size:24px;font-weight:bold;margin-bottom:15px;">{{$t('menu_about')}}</div>
            <div class="row">
                <div class="col-md-3">
                    <div><img src="/static/images/about us-factory.jpg" class="responsive"/></div>
                    <div class="about-title">{{$t('home_about_section_1')}}</div>
                    <div class="about-desc">{{$t('home_about_section_1_detail')}} </div>
                </div>

                <div class="col-md-3">
                    <div><img src="/static/images/about us-production.jpg" class="responsive"/></div>
                    <div class="about-title">{{$t('home_about_section_2')}}</div>
                    <div class="about-desc">{{$t('home_about_section_2_detail')}} </div>
                </div>
                <div class="col-md-3">
                    <div><img src="/static/images/about us-rd.jpg" class="responsive"/></div>
                    <div class="about-title">{{$t('home_about_section_3')}}</div>
                    <div class="about-desc">{{$t('home_about_section_3_detail')}} </div>
                </div>
                <div class="col-md-3">
                    <div><img src="/static/images/about us-delivery.jpg" class="responsive"/></div>
                    <div class="about-title">{{$t('home_about_section_4')}}</div>
                    <div class="about-desc">{{$t('home_about_section_4_detail')}} </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container" style="margin-bottom:40px;padding-left:10px;padding-right:10px;">
        <div style="margin:20px 0px;margin-top:50px;font-size:24px;color:#526193;font-weight:bold">{{$t('home_product')}}</div>
        <div class="all-products">
                
                
                
                <div class="row">
                    
                    <div class="col-md-3 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product114_logo.jpg" style="width:100%;height:100%">
                            </div>
                            <div class="about-title">
                                <a @click="jump('114')">{{$t('home_product_section_1')}}</a>
                            </div>
                            <div class="about-desc1">{{$t('home_product_section_1_detail')}}

                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-3 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product115_logo.jpg" style="width:100%;height:100%">
                            </div>
                            <div class="about-title">
                                <a @click="jump('115')">{{$t('home_product_section_2')}}</a>
                            </div>
                            <div class="about-desc1">{{$t('home_product_section_2_detail')}}


                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-3 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product57_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="about-title">
                                <a @click="jump('57')">{{$t('home_product_section_3')}}</a>
                            </div>
                            <div class="about-desc1">{{$t('home_product_section_3_detail')}}

                            </div>
                        </div>
                    </div>
                    
                    <div class="col-md-3 product">
                        <div class="product-area">
                            <div>
                                <img src="/static/images/product/product61_logo.png" style="width:100%;height:100%">
                            </div>
                            <div class="about-title">
                                <a @click="jump('61')">{{$t('home_product_section_4')}}</a>
                            </div>
                            <div class="about-desc1">{{$t('home_product_section_4_detail')}}
                            </div>
                        </div>
                    </div>
                    
                </div>
                
                
                
            </div>
    </div>

   <div class="block-reverse">
        <div class="container" style="padding:30px 10px">
            <div style="margin:20px 0px;margin-top:0px;font-size:24px;color:#526193;font-weight:bold">{{$t('home_adv')}}</div>
            <div class="about-title">
                <li>{{$t('home_adv_section_1')}}</li>
            </div>
            <p class="about-desc1">{{$t('home_adv_section_1_detail')}}            </p>

            <div class="about-title">
                <li>{{$t('home_adv_section_2')}}</li>
            </div>
            <p class="about-desc1">{{$t('home_adv_section_2_detail')}}            </p>

            <div class="about-title">
                <li>{{$t('home_adv_section_3')}}</li>
            </div>
            <p class="about-desc1">{{$t('home_adv_section_3_detail')}}            </p>
        </div>
    </div>
</div>
</template>

<script>

import bus from '../util/bus';
export default {
    created(){
    
    },
    mounted(){
        document.getElementById("video").addEventListener("canplaythrough", ()=> {
       
        });
    },
    components: {
        
    },
    methods:{
        gotoUrl(url){
            $(window).scrollTop(0);
            this.$router.push(url);
        },
        jump(id){
            $(window).scrollTop(0);
            this.$router.push('product?id='+id);
            bus.$emit('changeproduct');
        },
        canplay(){
            console.log('play')
        }
    },
    data(){
        return{
           
        }
    }
};
</script>

<style>
.header-part{
    padding:30px 0px;
}
.header-text{
    font-size:32px;
    margin-bottom:10px;
    font-weight:bold;
}

.responsive{
    width:100%;
    height:auto;
}

.block{
    margin:50px 0px;
}

.part-columns img{
   
    border-radius:2px;
    height:230px;
    width:100%;
    
}

.about-title{
    margin-top:15px;
    margin-bottom:10px;
    font-size:18px;
    font-weight:bold;
    color:#333;
}

.about-desc{
    font-size:14px;
}

.about-desc1{
    color:#666;
    font-size:14px;
}

.product-area{

    margin-bottom:30px;
}

.product-title{
    margin-top:15px;
}

.product-area img{

  
}

@media (max-width:520px){
    .about-title{
        margin-bottom:3px;
        font-weight:bold;
    }
    .about-desc{
        margin-bottom:15px;
        color:#666;
    }
}

.product-area a:hover{
    font-weight:bold;
    color:#526193!important;
    text-decoration:none;
}

.part-column-title{
    margin:15px 0px 10px 0px;
}

.part-column-text{
    color:#869ab8!important;
    margin-bottom:15px;
}

.block-reverse{
    background:#E9ECF4;
    padding:20px 0px;
}
</style>



// WEBPACK FOOTER //
// index.vue?c394add0